import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import PartnerNode from './partner-node';
import BillingInfoNode from './billing-info-node.jsx';
import PoliciesNode from './policies/policies-node';
import CheckinCheckout from './checkinout.jsx';
import TermsCriteriaNode from './terms-criteria-node';

const Seller = ({
  supplierInfo,
  locationPolicy,
  billingInformation,
  supplierEditable,
  openAddEditContractDialog,
  contractState,
  locationId,
  propsForCheckInCheckOut,
  isPartner,
  partners = [],
  contacts = [],
  from = {},
  to = {},
}) => {
  const supplierIsSender = Boolean(locationId);
  return (
    <div style={{ overflow: 'auto', padding: '0 2%', width: '50%', margin: '8px 0', float: 'left', fontSize: '14px' }}>
      <div
        style={{
          marginLeft: '10%',
          width: '85%',
          padding: '24px',
          border: '1px solid #e0e0e0',
          borderRadius: '5px',
        }}
      >
        <b>{supplierIsSender ? 'Supplier' : 'Contract Request prepared for'}</b>
        {
          supplierIsSender ? (
            <div>
              {from.email.indexOf('dl+') === -1 ? from.email : ''}
            </div>
          ) : (
            <div>
              {to.name}
            </div>
          )
        }
        {
          isPartner
          && (
            <div style={{ marginTop: '8px' }}>
              <PartnerNode
                isReceiver={!supplierIsSender}
                partners={partners}
                contacts={contacts}
              />
            </div>
          )
        }
      </div>
      <TermsCriteriaNode {...supplierInfo} contractState={contractState} editable={supplierEditable} openAddEditContractDialog={openAddEditContractDialog} forSupplier />
      <PoliciesNode locationPolicy={locationPolicy} contractState={contractState} supplierEditable={supplierEditable} openAddEditContractDialog={openAddEditContractDialog} />
      <CheckinCheckout {...propsForCheckInCheckOut} />
      <BillingInfoNode {...billingInformation} contractState={contractState} supplierEditable={supplierEditable} openAddEditContractDialog={openAddEditContractDialog} />
    </div>
  );
};

Seller.propTypes = {
  locationPolicy: PropTypes.array,
  supplierEditable: PropTypes.bool,
  openAddEditContractDialog: PropTypes.func,
};

const mapState = ({
  contracting: {
    contractActivitiesProducts,
  },
}, { openAddEditContractDialog }) => {
  const rightSideContent = contractActivitiesProducts.get('rightSideContent').toJS();
  const leftNav = contractActivitiesProducts.get('leftNav').toJS();
  return {
    isPartner: leftNav.viewingAs === 'Buyer',
    partners: leftNav.partners,
    contacts: leftNav.contacts,
    contractorEditable: leftNav.contractorEditable,
    supplierEditable: leftNav.supplierEditable,
    contractState: leftNav.contractState,
    locationId: leftNav.locationId,
    contractId: leftNav.contractId,
    from: leftNav.from,
    to: leftNav.to,
    toEmails: leftNav.toEmails,
    propsForCheckInCheckOut: {
      openAddEditContractDialog,
      supplierEditable: leftNav.supplierEditable,
      checkIn: rightSideContent.checkIn,
      checkOut: rightSideContent.checkOut,
      earlyCheckIn: rightSideContent.earlyCheckIn,
      earlyCheckInCostType: rightSideContent.earlyCheckInCostType,
      earlyCheckInPercentageType: rightSideContent.earlyCheckInPercentageType,
      earlyCheckInFee: rightSideContent.earlyCheckInFee,
      lateCheckOut: rightSideContent.lateCheckOut,
      lateCheckOutCostType: rightSideContent.lateCheckOutCostType,
      lateCheckOutFee: rightSideContent.lateCheckOutFee,
      lateCheckOutPercentageType: rightSideContent.lateCheckOutPercentageType,
    },
  };
};

export default connect(mapState)(Seller);



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-activities-products/contract-policies/seller.jsx